import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  top: 40px;\n  right: 3px;\n  height: 24px;\n  width: 50px;\n  font-size: 12px;\n  color: #363f41;\n  cursor: pointer;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  position: absolute;\n  top: 30px;\n  right: 10px;\n  padding: 14px 0px;\n  width: 50px;\n  font-size: 12px;\n  color: #363f41;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  cursor: pointer;\n  transition: all 300ms ease;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { compose, withHandlers, withProps, withState } from 'recompose';
import { AcornsIcon } from '@acorns/icons';
import { TextInput } from '../../Form/TextInput';
import styled from '../../utils/styling/styled-components';
import { PRIVATE_INPUT_TOGGLE } from '../../utils/testing/TestIDs';
var Container = styled.div(_templateObject());
var ShowHideToggle = styled.div(_templateObject2());
var EyeballIcon = styled.svg(_templateObject3());
var enhance = compose(withState('type', 'setType', 'password'), withProps(function (props) {
  return {
    isMasked: props.type === 'password'
  };
}), withHandlers({
  toggleMask: function toggleMask(_ref) {
    var setType = _ref.setType,
        props = _objectWithoutProperties(_ref, ["setType"]);

    return function () {
      setType(!props.isMasked ? 'password' : 'text');
    };
  }
}));
var PrivateInput = enhance(function (_ref2) {
  var toggleMask = _ref2.toggleMask,
      _ref2$hasRevealToggle = _ref2.hasRevealToggle,
      hasRevealToggle = _ref2$hasRevealToggle === void 0 ? true : _ref2$hasRevealToggle,
      isMasked = _ref2.isMasked,
      props = _objectWithoutProperties(_ref2, ["toggleMask", "hasRevealToggle", "isMasked"]);

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(TextInput, props), hasRevealToggle && props.toggleIcon && /*#__PURE__*/React.createElement(EyeballIcon, {
    onClick: toggleMask
  }, /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.Eyeball
  })), hasRevealToggle && !props.toggleIcon && /*#__PURE__*/React.createElement(ShowHideToggle, {
    "data-testid": PRIVATE_INPUT_TOGGLE,
    onClick: toggleMask
  }, isMasked ? 'Show' : 'Hide'));
});
export { PrivateInput };